import AOS from 'AOS';

AOS.init({
  easing: 'ease',
  duration: 1000,
  once: true,
  useClassNames: true,
  initClassName: false,
  animatedClassName: 'aos-animate',
});